// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DocumentVerification-space1-EuSb_ {
	margin-bottom: 6px !important;
}

.DocumentVerification-space2-sf1pA {
	margin-bottom: 12px !important;
}

.DocumentVerification-space3-RRE2r {
	margin-bottom: 18px !important;
}

.DocumentVerification-space4-pWJrK {
	margin-bottom: 24px !important;
}

.DocumentVerification-space5-C55Ko {
	margin-bottom: 30px !important;
}

.DocumentVerification-space6-bSy5L {
	margin-bottom: 36px !important;
}

.DocumentVerification-space7-zEkTa {
	margin-bottom: 42px !important;
}

.DocumentVerification-space8-eNHPh {
	margin-bottom: 48px !important;
}

.DocumentVerification-spaceTop1-AXAw2 {
	margin-top: 6px !important;
}

.DocumentVerification-spaceTop2-NA4px {
	margin-top: 12px !important;
}

.DocumentVerification-spaceTop3-cervI {
	margin-top: 18px !important;
}

.DocumentVerification-spaceTop4-YQXv6 {
	margin-top: 24px !important;
}

.DocumentVerification-spaceTop5-u9dmV {
	margin-top: 30px !important;
}

.DocumentVerification-spaceTop6-ppoBV {
	margin-top: 36px !important;
}

.DocumentVerification-spaceTop7-iKxqH {
	margin-top: 42px !important;
}

.DocumentVerification-spaceTop8-d7swN {
	margin-top: 48px !important;
}

.DocumentVerification-noMargin-IqPP4 {
	margin: 0px !important;
}

.DocumentVerification-padding1-Ux2DO {
	padding-bottom: 6px !important;
}

.DocumentVerification-padding2-BYWiD {
	padding-bottom: 12px !important;
}

.DocumentVerification-padding3-vAm6r {
	padding-bottom: 18px !important;
}

.DocumentVerification-padding4-d6qcf {
	padding-bottom: 24px !important;
}

.DocumentVerification-padding5-Jwcj0 {
	padding-bottom: 30px !important;
}

.DocumentVerification-padding6-AEDlH {
	padding-bottom: 36px !important;
}

.DocumentVerification-padding7-q9A3h {
	padding-bottom: 42px !important;
}

.DocumentVerification-paddingTop1-N1RAF {
	padding-top: 6px !important;
}

.DocumentVerification-paddingTop2-HJurT {
	padding-top: 12px !important;
}

.DocumentVerification-paddingTop3-TDp4b {
	padding-top: 18px !important;
}

.DocumentVerification-paddingTop4-Urz77 {
	padding-top: 24px !important;
}

.DocumentVerification-paddingTop5-kT6fD {
	padding-top: 30px !important;
}

.DocumentVerification-paddingTop6-wNNal {
	padding-top: 36px !important;
}

.DocumentVerification-paddingTop7-rYh7e {
	padding-top: 42px !important;
}

.DocumentVerification-noPadding-Y1IWK {
	padding: 0px !important;
}

.DocumentVerification-spaceMarginBottom0-lDEci {
	margin-bottom: 0;
}

.DocumentVerification-textBold-WnRPu {
	font-weight: 500 !important;
}

.DocumentVerification-textBolder-mAw6Z {
	font-weight: 700 !important;
}

.DocumentVerification-textNormal-ke84l {
	font-weight: normal !important;
}

/*New Design Text Colors */

.DocumentVerification-textDarkBlue-lfiam {
	color: rgb(20, 39, 94) !important;
}

.DocumentVerification-textLightBlue-DR2i0 {
	color: rgb(57, 87, 106) !important;
}

.DocumentVerification-textLightSandleGreen-_Ti1b {
	color: rgb(76, 86, 41) !important;
}

.DocumentVerification-textLightBrown-HAm66 {
	color: rgb(115, 79, 33) !important;
}

.DocumentVerification-textMediumMaroon-amBll {
	color: rgb(87, 37, 51) !important;
}

.DocumentVerification-textBrown-RJVWb {
	color: rgb(160, 47, 24) !important;
}

.DocumentVerification-textMaroon-gY2EC {
	color: rgb(155, 49, 67) !important;
}

.DocumentVerification-textDarkBrown-Bjxit {
	color: rgb(83, 18, 16) !important;
}

.DocumentVerification-textMediumBrown-f5MmA {
	color: rgb(142, 28, 10) !important;
}

.DocumentVerification-textSkyBlue-Bl6ft {
	color: rgb(37, 117, 141) !important;
}

.DocumentVerification-textGray-_eaNn {
	color: rgb(77, 65, 51) !important;
}

.DocumentVerification-errorMessage-QhYxY {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.DocumentVerification-userText-In4GG {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.DocumentVerification-panelHeader-iutZc {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.DocumentVerification-exportSection-PUihD {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.DocumentVerification-exportSectionGridSub-AlysU {
	grid-template-columns: 50% 49% !important;
}

.DocumentVerification-exportText-hK3HJ {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.DocumentVerification-exportLinkImg-mvjll {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.DocumentVerification-exportImg-rOlA9 {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.DocumentVerification-linkBtn-cFAhk {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.DocumentVerification-table-mLDrI {
	display: table;
}

.DocumentVerification-tableRow-G9WXG {
	display: table-row;
}

.DocumentVerification-tableCell-YCPsF {
	display: table-cell;
	float: none;
}

.DocumentVerification-formGroup-zgTls {
	margin-bottom: 6px;
}

.DocumentVerification-marginTop0-JbjIP {
	margin-top: 0;
}

.DocumentVerification-marginBottom20-EBgbd {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.DocumentVerification-bannerImageBg-xLknb {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.DocumentVerification-bannerDelete-luUyd {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.DocumentVerification-exportLink-XHdog {
	padding-top: 10px;
	padding-right: 10px;
}

.DocumentVerification-seachContent-IHt3Q {
	padding-left: 0px;
	margin-bottom: 5px;
}

.DocumentVerification-marginBottom9-LIzD8 {
	margin-bottom: 9px;
}

.DocumentVerification-spaceTop52-ET80q {
	margin-top: 52px;
}

.DocumentVerification-profileViewInner-BkfX6 {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.DocumentVerification-profileViewMain-fvY6v {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.DocumentVerification-profileViewlabel-rHJ1I {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.DocumentVerification-profileViewMainContent-JeOLB {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.DocumentVerification-reviewsFormStar-SkyMU {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.DocumentVerification-reviewsFormStar-SkyMU svg {
	cursor: pointer;
}

.DocumentVerification-addLanguageText-TvY7b {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.DocumentVerification-exportSection-PUihD {
		grid-template-columns: 100%;
	}

	.DocumentVerification-spaceTop52-ET80q {
		margin-top: 18px;
	}

	.DocumentVerification-exportText-hK3HJ {
		float: none;
		margin-top: 12px;
	}

	.DocumentVerification-exportSectionGridSub-AlysU {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.DocumentVerification-profileViewlabel-rHJ1I {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.DocumentVerification-profileViewMainContent-JeOLB {
		width: 100%;
		text-align: center;
	}

	.DocumentVerification-panelHeader-iutZc {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `DocumentVerification-space1-EuSb_`,
	"space2": `DocumentVerification-space2-sf1pA`,
	"space3": `DocumentVerification-space3-RRE2r`,
	"space4": `DocumentVerification-space4-pWJrK`,
	"space5": `DocumentVerification-space5-C55Ko`,
	"space6": `DocumentVerification-space6-bSy5L`,
	"space7": `DocumentVerification-space7-zEkTa`,
	"space8": `DocumentVerification-space8-eNHPh`,
	"spaceTop1": `DocumentVerification-spaceTop1-AXAw2`,
	"spaceTop2": `DocumentVerification-spaceTop2-NA4px`,
	"spaceTop3": `DocumentVerification-spaceTop3-cervI`,
	"spaceTop4": `DocumentVerification-spaceTop4-YQXv6`,
	"spaceTop5": `DocumentVerification-spaceTop5-u9dmV`,
	"spaceTop6": `DocumentVerification-spaceTop6-ppoBV`,
	"spaceTop7": `DocumentVerification-spaceTop7-iKxqH`,
	"spaceTop8": `DocumentVerification-spaceTop8-d7swN`,
	"noMargin": `DocumentVerification-noMargin-IqPP4`,
	"padding1": `DocumentVerification-padding1-Ux2DO`,
	"padding2": `DocumentVerification-padding2-BYWiD`,
	"padding3": `DocumentVerification-padding3-vAm6r`,
	"padding4": `DocumentVerification-padding4-d6qcf`,
	"padding5": `DocumentVerification-padding5-Jwcj0`,
	"padding6": `DocumentVerification-padding6-AEDlH`,
	"padding7": `DocumentVerification-padding7-q9A3h`,
	"paddingTop1": `DocumentVerification-paddingTop1-N1RAF`,
	"paddingTop2": `DocumentVerification-paddingTop2-HJurT`,
	"paddingTop3": `DocumentVerification-paddingTop3-TDp4b`,
	"paddingTop4": `DocumentVerification-paddingTop4-Urz77`,
	"paddingTop5": `DocumentVerification-paddingTop5-kT6fD`,
	"paddingTop6": `DocumentVerification-paddingTop6-wNNal`,
	"paddingTop7": `DocumentVerification-paddingTop7-rYh7e`,
	"noPadding": `DocumentVerification-noPadding-Y1IWK`,
	"spaceMarginBottom0": `DocumentVerification-spaceMarginBottom0-lDEci`,
	"textBold": `DocumentVerification-textBold-WnRPu`,
	"textBolder": `DocumentVerification-textBolder-mAw6Z`,
	"textNormal": `DocumentVerification-textNormal-ke84l`,
	"textDarkBlue": `DocumentVerification-textDarkBlue-lfiam`,
	"textLightBlue": `DocumentVerification-textLightBlue-DR2i0`,
	"textLightSandleGreen": `DocumentVerification-textLightSandleGreen-_Ti1b`,
	"textLightBrown": `DocumentVerification-textLightBrown-HAm66`,
	"textMediumMaroon": `DocumentVerification-textMediumMaroon-amBll`,
	"textBrown": `DocumentVerification-textBrown-RJVWb`,
	"textMaroon": `DocumentVerification-textMaroon-gY2EC`,
	"textDarkBrown": `DocumentVerification-textDarkBrown-Bjxit`,
	"textMediumBrown": `DocumentVerification-textMediumBrown-f5MmA`,
	"textSkyBlue": `DocumentVerification-textSkyBlue-Bl6ft`,
	"textGray": `DocumentVerification-textGray-_eaNn`,
	"errorMessage": `DocumentVerification-errorMessage-QhYxY`,
	"userText": `DocumentVerification-userText-In4GG`,
	"panelHeader": `DocumentVerification-panelHeader-iutZc`,
	"exportSection": `DocumentVerification-exportSection-PUihD`,
	"exportSectionGridSub": `DocumentVerification-exportSectionGridSub-AlysU`,
	"exportText": `DocumentVerification-exportText-hK3HJ`,
	"exportLinkImg": `DocumentVerification-exportLinkImg-mvjll`,
	"exportImg": `DocumentVerification-exportImg-rOlA9`,
	"linkBtn": `DocumentVerification-linkBtn-cFAhk`,
	"table": `DocumentVerification-table-mLDrI`,
	"tableRow": `DocumentVerification-tableRow-G9WXG`,
	"tableCell": `DocumentVerification-tableCell-YCPsF`,
	"formGroup": `DocumentVerification-formGroup-zgTls`,
	"marginTop0": `DocumentVerification-marginTop0-JbjIP`,
	"marginBottom20": `DocumentVerification-marginBottom20-EBgbd`,
	"bannerImageBg": `DocumentVerification-bannerImageBg-xLknb`,
	"bannerDelete": `DocumentVerification-bannerDelete-luUyd`,
	"exportLink": `DocumentVerification-exportLink-XHdog`,
	"seachContent": `DocumentVerification-seachContent-IHt3Q`,
	"marginBottom9": `DocumentVerification-marginBottom9-LIzD8`,
	"spaceTop52": `DocumentVerification-spaceTop52-ET80q`,
	"profileViewInner": `DocumentVerification-profileViewInner-BkfX6`,
	"profileViewMain": `DocumentVerification-profileViewMain-fvY6v`,
	"profileViewlabel": `DocumentVerification-profileViewlabel-rHJ1I`,
	"profileViewMainContent": `DocumentVerification-profileViewMainContent-JeOLB`,
	"reviewsFormStar": `DocumentVerification-reviewsFormStar-SkyMU`,
	"addLanguageText": `DocumentVerification-addLanguageText-TvY7b`
};
module.exports = ___CSS_LOADER_EXPORT___;
